import { useEffect } from "react"
import { observer } from "mobx-react-lite"
import InfiniteScroll from "react-infinite-scroll-component"
import { Box, Badge, Group } from "@mantine/core"
import { ArticleListElement } from "entities/article"
import { ArticleListElementSkeleton } from "./ArticleListElementSkeleton"
import { ArticleStore } from "../../../app/store"
import { ErrorResult } from "../../../shared/ui/ErrorResult"
import { EmptyResult } from "../../../shared/ui/EmptyResult"

// ----------------------------------------------------------------------

export const ArticleList = observer(function ArticleList() {
  const { articles, initialLoad, loadMore, isLoading, totalCount, error } = ArticleStore

  useEffect(() => {
    void initialLoad()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const renderInfo = () => {
    if (isLoading) {
      return <ArticleListElementSkeleton/>
    }

    if (error) {
      return <ErrorResult errorMessage={error}/>
    }

    if (!articles.length) {
      return <EmptyResult/>
    }

    return (
      <Group position="center">
        <Badge color="gray" size="lg" mt="xl">
          Вы загрузили все статьи
        </Badge>
      </Group>
    )
  }

  return (
    <Box>
      <InfiniteScroll
        next={loadMore}
        dataLength={articles.length}
        hasMore={totalCount !== articles.length}
        loader={<ArticleListElementSkeleton/>}
        endMessage={renderInfo()}
      >
        {articles.map((article) => (
          <ArticleListElement key={article._id} {...article} />
        ))}
      </InfiniteScroll>
    </Box>
  )
})
